import React, { FC } from 'react';
import classNames from 'classnames';
import { InfoPair, InfoValuePairDataType } from './InfoPair';
import styles from './styles.module.css';

const FS_EXCLUDE_ITEMS = [
  'Policy Holder',
  'Date of Birth',
  'Email Address',
  'Home Phone',
  'Cell Phone',
  'Garaging Address',
  'Lienholder address',
  'Gender',
  'Marital status',
];

export type CardSectionInfoPairsType = {
  headers: string[];
  data: InfoValuePairDataType[];
  dataFontStyle?: 'capitalize' | 'none';
  className?: string;
  hiddenColumns?: Array<string>;
  loading?: boolean;
  copyable?: boolean;
  dataTestIdPrefixes?: Array<string | undefined>;
};

export const CardSectionInfoPairs: FC<CardSectionInfoPairsType> = ({
  headers,
  data,
  dataFontStyle = 'capitalize',
  className = '',
  hiddenColumns = [],
  loading = false,
  copyable = true,
  dataTestIdPrefixes,
}) => (
  <div
    className={classNames(
      styles.container,
      {
        [styles.oneColumns]: data.length === 1,
        [styles.twoColumns]: data.length === 2 || data.length === 1,
        [styles.threeColumns]: data.length === 3,
      },
      className
    )}
  >
    {headers.map((header, index) => {
      if (hiddenColumns.includes(header)) return null;
      return (
        <div key={`${header}-${index}`} className={styles.infoPair}>
          <InfoPair
            copyable={copyable}
            header={header}
            data={data[index]}
            dataFontStyle={dataFontStyle}
            dataClassName={
              FS_EXCLUDE_ITEMS.includes(header) ? 'fs-exclude' : ''
            }
            loading={loading}
            dataTestIdPrefix={
              dataTestIdPrefixes === undefined
                ? undefined
                : dataTestIdPrefixes[index]
            }
          />
        </div>
      );
    })}
  </div>
);
